import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  ReactiveFormsModule,
  FormControl,
  Validators,
  FormBuilder,
  FormGroup
} from '@angular/forms';

import { DashboardComponent } from '../dashboard/dashboard.component';
import { NotFoundComponent } from '../not-found/not-found.component';
import { ProfileComponent } from '../profile/profile.component';
import { NotificationsComponent } from '../notifications/notifications.component';
import { SearchResultComponent } from '../search-result/search-result.component';

// Ticket Menu
import { TicketModule } from '../ticket';

// User Management Menu
import { UserManagementModule } from '../user-management';

// Notif Modals
import { SharedLayoutModule } from '../_shared/layout/shared-layout.module';

import { NavbarComponent, NavbarRoutingModule } from '../navbar';
import { AuthGuard } from '../_shared';

// Custom Scrollbar
import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface
} from 'ngx-perfect-scrollbar';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  scrollXMarginOffset: 4,
  scrollYMarginOffset: 4
};

import { NgxPaginationModule } from 'ngx-pagination';
import { MaterialModule } from '../material.module';
import { PipeModule } from '../_shared/pipes/pipe.module';
import { MenuResolver } from '../_shared/resolvers';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NavbarRoutingModule,
    PerfectScrollbarModule,
    NgxPaginationModule,
    MaterialModule,
    TicketModule,
    UserManagementModule,
    PipeModule,
    SharedLayoutModule
  ],
  declarations: [
    NavbarComponent,
    DashboardComponent,
    NotFoundComponent,
    ProfileComponent,
    NotificationsComponent,
    SearchResultComponent
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    AuthGuard,
    MenuResolver
  ]
})
export class NavbarModule {}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/navbar/navbar.module.ts